
import React from 'react';
import './Thesis.css'; 

const Thesis = () => {
  return (
    <div className='thesis-container'>
      <h2>With a decade spent on this initiative and massive number of resources poured into it, one must surely ask questions regarding it. Hence, this evaluation critically examines the Belt and Road Initiative (BRI) by assessing its promoted intentions, the ethicality of its methods to successfully complete projects, and the overall impact on participating countries. While the BRI aims to promote global connectivity and economic development, the analysis reveals an interplay between China’s strategic motives, questionable implementation practices, and mixed outcomes, raising significant concerns about its true benefits and long-term sustainability. This establishes the team’s stand of not fully in favour of the BRI and the hidden negative effects it inflicts on all participating countries. </h2>
    </div>
  );
};

export default Thesis;
